export default "__VITE_ASSET__BrNIcIVT__"